import { loginRequest } from "../auth/authConfig";

// Fetch profile info and image from Microsoft Graph
export const getUserProfile = async (instance, account) => {
  if (!account) throw new Error("No active account found.");

  try {
    // 1️⃣ Get access token for Graph API
    const response = await instance.acquireTokenSilent({
      ...loginRequest,
      account,
    });

    const accessToken = response.accessToken;

    // 2️⃣ Fetch profile details (name, email, job title, etc.)
    const profileResponse = await fetch("https://graph.microsoft.com/v1.0/me", {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const profileData = await profileResponse.json();

    // 3️⃣ Fetch profile picture
    const photoResponse = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    let profilePic = null;
    if (photoResponse.ok) {
      const blob = await photoResponse.blob();
      profilePic = URL.createObjectURL(blob);
    }

    return {
      name: profileData.displayName,
      email: profileData.mail || profileData.userPrincipalName,
      jobTitle: profileData.jobTitle || "",
      image:profilePic,
    };
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};